/*
 * @Description: 受众好感图对比
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-26 10:35:19
 * @LastEditTime: 2019-08-02 13:54:10
 */

const splitStr = (str) => {
  return str.split(' ').join('\n');
  // return str.replace(/(.{6})/g, '$1' + '\n')
};

// 将数据分成 普通账号（mua）和kol账号
const classify = (list) => {
  const general = [];
  const kol = [];

  list.forEach((item) => {
    if(item.type === '普通账号') {
      general.push(item);
    } else {
      kol.push(item);
    }
  });

  const _general = general.sort((a, b) => -!(a > b));
  const _kol = kol.sort((a, b) => -!(a > b));
  const result = {
    general: [],
    kol: [],
    title: []
  };

  _general.forEach((item, index) => {
    result.general.push(item.value);
    result.title.push(splitStr(item.name));
    result.kol.push(_kol[index].value);
  });

  return result;
};

export default (data, query) => {

  const chartList = classify(data);

  const color = query.color || {
    kol: '#ffd70d',
    general: '#fffb0e'
  };

  console.log(chartList.title);
  
  
  return {
    angleAxis: {
      type: 'category',
      data: chartList.title,
      z: 10,
      axisLabel: {
        margin: 2
      }
    },
    radiusAxis: {
    },
    polar: {
      radius: '72%'
    },
    graphic: [
      {
        type: 'text',
        left: 'center',
        bottom: 0,
        z: 100,
        style: {
          fontSize: 16,
          text: query.title,
          stroke: '#44548f',
          font: '14px "STHeiti", sans-serif'
        }
      }
    ],
    series: [{
      type: 'bar',
      data: chartList.kol,
      coordinateSystem: 'polar',
      name: 'KOL用户',
      stack: 'a',
      label: {
        // fomatter: (...val) => {
        //   console.log(val);
        //   return 'safasd'
          
        // }
      },
      itemStyle: {
        normal: {
          color: color.kol
        }
      }
    }, {
      type: 'bar',
      data: chartList.general,
      coordinateSystem: 'polar',
      name: '普通用户',
      stack: 'a',
      label: {

      },
      itemStyle: {
        normal: {
          color: color.general
        }
      }
    }],
    legend: {
      show: true,
      data: ['KOL用户', '普通用户']
    }
  };
}



// WEBPACK FOOTER //
// src/chart/favorComplatePolar.js